export default __webpack_public_path__ + "static/media/book-one.58f6df58.png";